import React from "react";
import { View } from "react-native";

import Image from "$src/core/components/atoms/Image/Image";

import $ from "./HeroGradientMaskedImage.web.styles";
import type { GradientMaskedImageProps } from "./types";

const HeroGradientMaskedImage: React.FC<GradientMaskedImageProps> = ({
  image,
  placeholder,
  style,
  onLayout,
  onLoad,
}) => (
  <View style={[$.view, style]} onLayout={onLayout}>
    {/* This is a decorative image, so we don't need an accessibility label */}
    {/* eslint-disable-next-line triple-rn-a11y/accessibility-label */}
    <Image
      accessibilityRole="none"
      source={image}
      contentFit="cover"
      placeholder={placeholder}
      placeholderContentFit="cover"
      style={$.image}
      onLoad={onLoad}
      priority="high"
    />
  </View>
);

export default HeroGradientMaskedImage;
